<footer class="tech-stack-footer">
  <div class="footer-container">
    <!-- Contact Support Section -->
    <div class="footer-top">
      <h3 class="contact-title">Contact Support</h3>
      <div class="divider"></div>
    </div>

    <!-- Footer Content -->
    <div class="footer-content">
      <!-- Left Side: Logo -->
      <div class="footer-left">
        <div class="logo-container">
          <img
            src="assets/icons/white_logo.svg"
            alt="AstraZeneca"
            class="az-logo"
          />
        </div>
      </div>

      <!-- Right Side: Description -->
      <div class="footer-right">
        <p class="footer-description">
          The ECS SE TechStack portal enables the Software Engineering team in
          Enterprise Capabilities and Solutions to visualize and track the
          technologies used in each project, along with their end-of-life dates
          and certificate expirations. Users can also add comments as needed,
          making it easier to manage technology lifecycles and communicate
          across projects.
        </p>
        <p class="version-info">TechStack v2.0.0</p>
      </div>
    </div>
  </div>
</footer>
